import { useQuery } from "@tanstack/react-query";
import { http } from "../../utils";

async function getSummary() {
  const { data } = await http("/admin/summary");
  return data;
}

export const useSummary = () => {
  return useQuery({
    queryKey: ["summary"],
    queryFn: () => getSummary(),
  });
};
